import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useMsalAccount } from '@/auth/use-msal-account';

type Props = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const FirstTimeConsentToUsageAnalyticsDialog = ({ isOpen, onOpenChange }: Props) => {
  const { activeAccount } = useMsalAccount();

  const { t } = useTranslation();

  if (!isOpen || !activeAccount) return null;

  return (
    <Dialog open={isOpen}>
      <DialogContent
        hideCloseButton
        className="min-w-[90%] lg:min-w-[30%]"
        onInteractOutside={() => {}}
      >
        <DialogHeader>
          <DialogTitle>{t('usage_analytics_collection_first_time_modal.title')}</DialogTitle>
          <DialogDescription>
            {t('usage_analytics_collection_first_time_modal.message')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col md:flex-row space-y-2 sm:space-y-0">
          <Button className="w-full md:w-1/2" variant="outline" onClick={() => onOpenChange(false)}>
            {t('usage_analytics_collection_first_time_modal.usageAnalayticsDisable')}
          </Button>
          <Button className="w-full md:w-1/2" onClick={() => onOpenChange(true)}>
            {t('usage_analytics_collection_first_time_modal.usageAnalayticsEnable')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
